import {
  IonContent,
  IonLabel,
  IonSegment,
  IonSegmentButton,
  IonSkeletonText,
} from "@ionic/react";
import React from "react";

const Skeleton__OptionsGridViewModal: React.FC = () => {
  return (
    <>
      <div style={{ padding: "0 10px" }}>
        <IonSegment>
          <IonSegmentButton value="call">
            <IonLabel>
              <IonSkeletonText animated={true} style={{ width: "60px" }} />
            </IonLabel>
          </IonSegmentButton>
          <IonSegmentButton value="put">
            <IonLabel>
              <IonSkeletonText animated={true} style={{ width: "60px" }} />
            </IonLabel>
          </IonSegmentButton>
        </IonSegment>
      </div>
      <IonContent>
        <div style={{ margin: "18px 13px" }}>
          <IonSkeletonText
            animated={true}
            style={{ width: "70%", height: "24px", marginBottom: "8px" }}
          />
          <IonSkeletonText
            animated={true}
            style={{ width: "40%", height: "16px", marginBottom: "20px" }}
          />
          <div style={{ marginBottom: "20px" }}>
            <IonSkeletonText
              animated={true}
              style={{ width: "100%", height: "20px", marginBottom: "4px" }}
            />
            {Array.from({ length: 3 }).map((_, index) => (
              <IonSkeletonText
                key={index}
                animated={true}
                style={{ width: "100%", height: "40px", marginBottom: "2px" }}
              />
            ))}
          </div>
          <div>
            <IonSkeletonText
              animated={true}
              style={{ width: "100%", height: "20px", marginBottom: "4px" }}
            />
            {Array.from({ length: 3 }).map((_, index) => (
              <IonSkeletonText
                key={index}
                animated={true}
                style={{ width: "100%", height: "40px", marginBottom: "2px" }}
              />
            ))}
          </div>
        </div>
      </IonContent>
    </>
  );
};

export default Skeleton__OptionsGridViewModal;
